import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const customSearchStyles = {
  icon: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.grey[500],
  }),
  input: (): SystemStyleObject<Theme> => ({
    paddingRight: "4px",
  }),
};

export default customSearchStyles;
